import axios, { AxiosError } from "axios";
import { ApiResult, ErrorResponseData, getDefaultHeaders } from "../common/api/Api";
import { DEFAULT_TIMEOUT, getAppEnv } from "../common/settings";

const appEnv = getAppEnv();

export const enum TenantPole {
  RE = "RE",
  RJ = "RJ",
  RUS = "RUS",
  RLA = "RLA",
  RAP = "RAP",
  RKR = "RKR",
}

export interface UserLoginResult {
  result: boolean;
  token?: string;
}

export const userLogin = async (
  tenantPole: string,
  userId: string,
  password: string,
): Promise<ApiResult<UserLoginResult, ErrorResponseData>> => {
  try {
    const url = `${appEnv.webApiEndPoint}/app/api/admin/login`;
    const requestBody = {
      tenantPole: tenantPole,
      userId: userId,
      password: password,
    };
    const headers = { headers: getDefaultHeaders(), timeout: DEFAULT_TIMEOUT };
    const response = await axios.post<UserLoginResult>(url, requestBody, headers);
    return { data: response.data };
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    return { error: err };
  }
};
